import { mapState } from 'vuex'
import ItemForm from '@/components/postEditor/items/ItemForm.vue'
import ItemPreview from '@/components/postEditor/parts/ItemPreview.vue'

export default {
  components: {
    ItemForm,
    ItemPreview
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  data: function () {
    return {
      edit: false,
      showBtns: false
    }
  },
  computed: {
    ...mapState({
      editingItemIndex: (state) => state.PostEditor.editingItemIndex,
      editingItemable: (state) => state.PostEditor.editingItemable
    })
  },
  methods: {
    editItem () {
      if (this.editingItemIndex == null) {
        const payload = {
          index: this.index,
          item: this.item
        }
        this.$store.commit('PostEditor/EDIT_ITEM', payload)
      }
    },
    updateEditingItemable: function (val, ...attrs) {
      let itemable = Object.assign({}, this.editingItemable)
      itemable = this.assignNestedAttributes(itemable, val, ...attrs)
      this.$store.commit('PostEditor/UPDATE_EDITING_ITEMABLE', itemable)
    },
    assignNestedAttributes (obj, val, ...attrs) {
      if (attrs.length === 1) {
        obj[attrs[0]] = val
      } else if (attrs.length >= 2) {
        obj[attrs[0]] = this.assignNestedAttributes({...obj[attrs[0]]}, val, ...attrs.slice(1))
      }
      return obj
    },
    switchItem (variety, index) {
      this.$store.commit('PostEditor/DELETE_ITEM', this.item.uuid)

      let newOrder
      if (this.item.isSaved) {
        newOrder = this.item.order
      } else {
        newOrder = null
      }
      const payload = {
        index: index,
        item: {
          id: null,
          variety: variety,
          order: newOrder,
          _destroy: false,
          newItem: true,
          itemableAttributes: itemableAttributesTemplate(variety)
        }
      }
      this.$store.commit('PostEditor/ADD_NEW_ITEM', payload)
    }
  }
}
const itemableAttributesTemplate = (variety) => {
  if (variety === 'table_item') {
    return {
      tableContent: {}
    }
  } else if (variety === 'html_table') {
    return {
      tableColumnFixed: -1,
      scrollable: false,
      htmlTableContent: [
        [
          {
            content: '',
            style: {
              backgroundColor: '',
              textAlign: '',
              width: '',
              height: ''
            }
          },
          {
            content: '',
            style: {
              backgroundColor: '',
              textAlign: '',
              width: '',
              height: ''
            }
          }
        ],
        [
          {
            content: '',
            style: {
              backgroundColor: '',
              textAlign: '',
              width: '',
              height: ''
            }
          },
          {
            content: '',
            style: {
              backgroundColor: '',
              textAlign: '',
              width: '',
              height: ''
            }
          }
        ]
      ]
    }
  }
}
